import { TifCalendarIcon } from '@/components/icons/tif/TifCalendarIcon';
import { tenantSelector } from '@/features/configuration/configurationSelector';
import { useSelector } from '@/store/utils';
import { Icons, type IconProps } from '@packages/webshop-design-system';

export const CalendarIcon = (props: IconProps) => {
  const { value: tenant } = useSelector(tenantSelector);

  const IconComponent =
    tenant === 'tifrance' ? TifCalendarIcon : Icons.calendar;

  return <IconComponent {...props} />;
};
